import { render, staticRenderFns } from "./FeedLike.vue?vue&type=template&id=0e72a8f2&scoped=true&"
import script from "./FeedLike.vue?vue&type=script&lang=js&"
export * from "./FeedLike.vue?vue&type=script&lang=js&"
import style0 from "./FeedLike.vue?vue&type=style&index=0&id=0e72a8f2&lang=scss&scoped=true&"
import style1 from "./FeedLike.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e72a8f2",
  null
  
)

export default component.exports